import { BrowserRouter, Routes, Route } from "react-router-dom"
import { MainLayout } from "@/components/layout/MainLayout"
import Overview from "@/pages/Overview"
import FlightSimulation from "@/pages/FlightSimulation"
import Telemetry from "@/pages/Telemetry"
import Experiments from "@/pages/Experiments"
import Workers from "@/pages/Workers"
import Runs from "@/pages/Runs"
import RunDetail from "@/pages/RunDetail"
import Comparison from "@/pages/Comparison"
import Settings from "@/pages/Settings"

function App() {
  return (
    <BrowserRouter>
      <MainLayout>
        <Routes>
          <Route path="/" element={<Overview />} />
          <Route path="/simulation" element={<FlightSimulation />} />
          <Route path="/telemetry" element={<Telemetry />} />
          <Route path="/experiments" element={<Experiments />} />
          <Route path="/workers" element={<Workers />} />
          <Route path="/runs" element={<Runs />} />
          <Route path="/runs/:id" element={<RunDetail />} />
          <Route path="/comparison" element={<Comparison />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
      </MainLayout>
    </BrowserRouter>
  )
}

export default App
